"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapSaleBanner = function mapSaleBanner(response) {
  var _response$body$;
  if (!response || !response.body) return false;
  var categoriesToDisplay = response.category_ids ? response.category_ids.replace(" ", "").split(",").map(function (id) {
    return parseInt(id);
  }) : false;
  var bannerContent = response.body.map(function (banner) {
    var _banner$primary$bigti, _banner$primary, _banner$primary$promo, _banner$primary$promo2, _banner$primary$subti, _banner$primary$linkt, _banner$primary$url;
    return {
      bigTitle: banner.primary.bigtitle && ((_banner$primary$bigti = banner.primary.bigtitle[0]) === null || _banner$primary$bigti === void 0 ? void 0 : _banner$primary$bigti.text),
      promoCode: (_banner$primary = banner.primary) === null || _banner$primary === void 0 ? void 0 : (_banner$primary$promo = _banner$primary.promocode) === null || _banner$primary$promo === void 0 ? void 0 : (_banner$primary$promo2 = _banner$primary$promo[0]) === null || _banner$primary$promo2 === void 0 ? void 0 : _banner$primary$promo2.text,
      subheading: banner.primary.subtitle && ((_banner$primary$subti = banner.primary.subtitle[0]) === null || _banner$primary$subti === void 0 ? void 0 : _banner$primary$subti.text),
      linkText: (_banner$primary$linkt = banner.primary.linktext[0]) === null || _banner$primary$linkt === void 0 ? void 0 : _banner$primary$linkt.text,
      url: (_banner$primary$url = banner.primary.url) !== null && _banner$primary$url !== void 0 && _banner$primary$url.url ? banner.primary.url.url.replace("https:/", "") : "/"
    };
  });
  return {
    categories: categoriesToDisplay,
    showInCategory: response.display_categorypage,
    showInProduct: response.display_productpage,
    content: bannerContent,
    background: response === null || response === void 0 ? void 0 : (_response$body$ = response.body[0]) === null || _response$body$ === void 0 ? void 0 : _response$body$.primary.background
  };
};
var _default = mapSaleBanner;
exports["default"] = _default;